import React from 'react'
import {useLocation, Link} from 'react-router-dom'
import useModal from '../../hooks/useModal'

export default ({modal: name, params = {}, children, ...props}) => {
  const location = useLocation()
  const {modalStack, searchParams} = useModal()

  // add or move name to end (top) of stack
  const newStack = [...modalStack.filter(n => n !== name), name]
  searchParams.set('modals', newStack.join(','))
  Object.entries(params).forEach(([key, value]) => searchParams.set(key, value))

  return (
    <Link {...props} to={{pathname: location.pathname, search: searchParams.toString()}}>
      {children}
    </Link>
  )
}
